import { Component, Input, Output, OnInit, EventEmitter} from '@angular/core';

@Component({
  selector: 'gf-image-modal',
  template: require('./image-modal.component.html')
})
export class ImageModalComponent {

  @Input() file: any;
  @Input() url: string;
  @Input() close: any;

  constructor() { }

  OnInit() {
  }
}
